<template>
  <div class="relative">
  <UPageHero
      :links="links"
      :ui="{
            root: 'hero-index min-h-lvh relative bg-cover bg-center bg-no-repeat overflow-hidden xl:bg-center flex items-start sm:items-center',
            container: 'lg:grid-cols-1 py-8',
            wrapper: 'lg:max-w-[54%] bg-neutral-100/80 rounded-lg p-8',
            description: 'mt-0 subline font-semibold',
            title: '!text-secondary',
            links: 'flex-col sm:max-w-2/3',
            body: 'mt-6'
        }"
      description="Sicher geplant. Nachhaltig umgesetzt."
      orientation="horizontal"
  >
    <template #title>Spielplätze für <br>öffentliche Lebensräume.</template>
    <template #body>
      <p class="hidden sm:block">Seit 1987 realisiert Sauerland Spielgeräte hochwertige und individuelle Spielräume für Kommunen, Schulen, Kitas und öffentliche Einrichtungen — mit Leidenschaft für Qualität, Sicherheit und Spielwert.</p>
      <div class="flex flex-wrap gap-2 mt-8 w-full">
        <UBadge
            v-for="badge in badges"
            :key="badge.id"
            v-bind="badge"
        />
      </div>
    </template>
    <template #links>
      <UButton
          v-for="link in links"
          :key="link.id"
          :block="smallerThanSm"
          :label="link.label"
          :to="link.to"
          :ui="{
            label: 'w-full text-center',
            base: link.variant === 'outline' ? 'bg-neutral-100' : ''
          }"
          :variant="link.variant"
          size="xl"
      />
    </template>
  </UPageHero>
    <div class="absolute bottom-0 left-0 w-full z-10 pointer-events-none">
      <BrandWave :amber-amplitude="60" :amber-frequency="2" :green-amplitude="60" :green-frequency="1" :height="300" :neutral-amplitude="30" :neutral-frequency="1" variant="trio"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type {ButtonProps} from '@nuxt/ui'
import {useBreakpoints, breakpointsTailwind} from '@vueuse/core';


const breakpoints = useBreakpoints(breakpointsTailwind, {
  ssrWidth: 1280,
});

const smallerThanSm = breakpoints.smaller('sm');

const usps: string[] = [
  'TÜV-zertifizierte Qualität nach DIN EN 1176',
  'Eigene Fertigung in Deutschland',
  'Individuelle Planung per 3D-Konfigurator',
  'Persönliche Beratung & Montage aus einer Hand',
];


const links = ref<ButtonProps[]>([
  {
    id: 0,
    label: 'Projekt anfragen',
    to: '/Service/Kontakt',
  },
  {
    id: 1,
    label: 'Produkte entdecken',
    to: '/kategorien',
    variant: 'outline',
  }
])

const badges = [
  {
    id: 0,
    label: 'TÜV- und GS-zertifiziert',
    icon: 'i-lucide-award',
    color: 'neutral',
    size: 'lg',
    variant: 'soft'
  },
  {
    id: 0,
    label: 'Nachhaltige Materialien',
    icon: 'i-lucide-leaf',
    color: 'neutral',
    size: 'lg',
    variant: 'soft'
  },
  {
    id: 0,
    label: 'Planung bis Montage',
    icon: 'i-lucide-wrench',
    color: 'neutral',
    size: 'lg',
    variant: 'soft'
  },
  {
    id: 0,
    label: 'Über 35 Jahre Erfahrung',
    icon: 'i-lucide-badge-check',
    color: 'neutral',
    size: 'lg',
    variant: 'soft'
  },
]
</script>

<style scoped>
.hero-index {
  background-image: url(/images/backgrounds/serie-4-0-category-image.png);
}
</style>

